import GeneralUtils from '../GeneralUtils.js'
function getTransition (count) {
  var single = count === undefined || count === null
  var transition = {
    duration: 1.5,
    easeOption: GeneralUtils.EasingOptions.SINE,
    easeDirection: GeneralUtils.EasingDirections.INOUT,
    delay: 0,
    values: {
      opacity: 1
    }
  }
  var transitionList = []
  if (!single) {
    for (var i = 0; i < count; i++) {
      transitionList.push(JSON.parse(JSON.stringify(transition)))
    }
  }
  return single ? JSON.parse(JSON.stringify(transition)) : transitionList
}
const TemplateUtils = {
  getTransition: getTransition
}
export default TemplateUtils



// WEBPACK FOOTER //
// ./src/components/utils/templates/TemplateUtils.js